/**
 * POST Company
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';
import { track } from '../../analytics/analytics';

import {
  ACTION_PUT_COMPANY,
  ACTION_PUT_COMPANY_SUCCESS,
  ACTION_PUT_COMPANY_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function update(company: any) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_PUT_COMPANY,
      payload: null,
    });

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'organization',
        method: 'put',
        data: JSON.stringify(company),
        success: (response: object) => {
          enqueueSnackbarHandler(
            dispatch,
            { updateCompanySuccess: true },
            'success',
          );
          dispatch(requestSuccess(response));
          handleTrack(response);
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_PUT_COMPANY_SUCCESS,
    payload: responeJSON,
  };
}

function requestFailed(responeJSON: object) {
  return {
    type: ACTION_PUT_COMPANY_FAILURE,
    payload: responeJSON,
  };
}

function handleTrack(data: any) {
  if (data.payload.id !== undefined) {
    let properties = {
      Company: data.payload.id,
      Modified: 'profile',
    };

    track('BB_CompanyUpdated', properties);
  }
}
